// src/components/RoomFormModal.js
import React, { useState, useEffect } from "react";

export default function RoomFormModal({ visible, onClose, onSubmit, room }) {
  const [form, setForm] = useState({
    roomNo: "",
    price: "",
    status: "Available",
  });

  useEffect(() => {
    if (room) {
      setForm({
        roomNo: room.roomNo || "",
        price: room.price || "",
        status: room.status || "Available",
      });
    } else {
      setForm({
        roomNo: "",
        price: "",
        status: "Available",
      });
    }
  }, [room]);

  if (!visible) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-40"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-2xl w-[400px] shadow-xl transform transition-all duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-semibold mb-4 text-gray-800">
          {room ? "Edit Room" : "Add New Room"}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* ROOM NUMBER */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Room Number
            </label>
            <input
              name="roomNo"
              placeholder="e.g. R001"
              value={form.roomNo}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            />
          </div>

          {/* PRICE */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Price (₦ per term)
            </label>
            <input
              name="price"
              type="number"
              min="0"
              placeholder="e.g. 450000"
              value={form.price}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            />
            <p className="mt-1 text-xs text-gray-500">
              Will display as{" "}
              <span className="font-medium">₦450,000</span> on the rooms table.
            </p>
          </div>

          {/* STATUS */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              name="status"
              value={form.status}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            >
              <option value="Available">Available</option>
              <option value="Occupied">Occupied</option>
              <option value="Maintenance">Maintenance</option>
            </select>
          </div>

          <div className="flex justify-end gap-3 mt-4">
            <button
              type="button"
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="px-5 py-2 rounded-md text-white font-semibold shadow bg-[#b4642d] hover:bg-[#9b5525] transition"
            >
              {room ? "Save Changes" : "Add Room"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
